import { parsePhoneNumber } from 'phonumber';
const formats = {
    US: {
        mask: '-###-###-####',
        withTail: false,
    },
};
export const formatPhoneNumber = (phoneString) => {
    if (!phoneString)
        return null;
    const parseResult = parsePhoneNumber(phoneString, { formats });
    return parseResult.formattedNumber.replace(' ', '');
};
//# sourceMappingURL=phoneNumber.js.map